import closeIcon from '@/assets/images/close_white.svg';
import './types.js';
import { menu } from './menu.js';
import { eventEmitter } from "../../utils/eventEmitter/index.js";
const styleSheet = new CSSStyleSheet();
styleSheet.replaceSync(`
  :host {
    display: flex;
    transform: translate(100%);
    padding: 20px;
    justify-content: center;
    align-items: center;
    position: absolute;
    right: 0;
    top: 0;
    height: 100dvh;
    width: 100%;
    z-index: 400;
    background-color: var(--color-toolbar);
    transition: transform 100ms ease-in;
  }

  :host(.opened) {
    transform: translate(0);
  }
  
  .close-icon {
    fill: var(--color-toolbar);
  }
  
  .menu {
    display: flex;
    flex-direction: column;
    width: 100%;
  }
  
  .menu-item {
    display: block;
    padding: 20px 10px;
    text-align: center;
    text-decoration: none;
    text-transform: uppercase;
    color: var(--color-main-background);
    font-weight: bold;
  }
  
  .close {
    position: absolute;
    top: 10px;
    right: 10px;
    width: 20px;
    height: 20px;
    padding: 0;
    background: transparent;
    border: none;
  }
  
  .close-icon {
    width: 100%;
    height: 100%;
  }
`);
export class TheToolbarMenuContentMobile extends HTMLElement {
    static tag = 'the-toolbar-menu-content-mobile';
    constructor() {
        super();
        this.attachShadow({ mode: 'open' }).adoptedStyleSheets = [styleSheet];
    }
    connectedCallback() {
        this.shadowRoot.innerHTML = `
      <button class="close">
        <img src="${closeIcon}" class="close-icon">
      </button>
      <nav class="menu"></nav>
    `;
        this.#renderMenu(this.#menu);
        eventEmitter.on('auth status update', () => {
            this.#renderMenu(this.#menu);
        });
        this.shadowRoot.querySelector('.close').addEventListener('click', this.#onCloseClick.bind(this));
    }
    hide() {
        this.classList.remove('opened');
    }
    show() {
        this.classList.add('opened');
    }
    toggleShow() {
        this.classList.toggle('opened');
    }
    /** @type {Menu} */
    #menu = menu;
    #onCloseClick() {
        this.hide();
    }
    #onLinkClick() {
        this.toggleShow();
    }
    /**
     * @param {Menu} val
     * */
    #renderMenu(val) {
        this.shadowRoot.querySelector('.menu').innerHTML = '';
        val.forEach(({ label, route, condition }) => {
            if (condition && !condition())
                return;
            const $a = document.createElement('a');
            $a.classList.add('menu-item');
            $a.href = route.to;
            $a.innerText = label;
            $a.addEventListener('click', this.#onLinkClick.bind(this));
            this.shadowRoot.querySelector('.menu').append($a);
        });
    }
}
customElements.define(TheToolbarMenuContentMobile.tag, TheToolbarMenuContentMobile);
